import { Link } from "react-router-dom";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <main className="mx-auto max-w-3xl px-4 py-10">
        <Link to="/" className="text-violet-400 hover:underline">← Back</Link>
        
        <h1 className="text-4xl font-bold mt-6 mb-4">Terms of Service</h1>
        <p className="text-white/50 mb-8"><strong>Effective Date:</strong> February 2, 2026</p>
        
        <div className="prose prose-invert max-w-none space-y-6 text-white/70">
          <p>
            OmniMark HQ is owned and operated by Nichols Global Business Services, LLC ("Company").
            By using OmniMark HQ, you agree to these Terms.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-8">Subscriptions, Credits, Trials</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Plans may be billed monthly or yearly.</li>
            <li>Trials may include limited credits/features and may be limited per user/business.</li>
            <li>Credits/charge-ups are generally non-refundable unless required by law.</li>
            <li>Export may require an upgrade and cannot be bypassed.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white mt-8">AI Outputs</h2>
          <p>
            Outputs are generated by AI and may be inaccurate. You are responsible for review,
            compliance with platform policies, and final publishing decisions.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-8">Acceptable Use</h2>
          <p>Do not use the Service to violate laws, platform policies, or third-party rights.</p>

          <h2 className="text-2xl font-semibold text-white mt-8">Contact</h2>
          <p>
            Use the <Link to="/contact" className="text-violet-400 hover:underline">Contact page</Link> on OmniMarkHQ.com.
          </p>
        </div>
      </main>
    </div>
  );
}
